import { Component, OnInit, Inject, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrderService } from 'src/app/service/order.service';
import { ProfileService } from 'src/app/shared/services/profile.service';

@Component({
  selector: 'app-customer-info',
  templateUrl: './customer-info.component.html',
  styleUrls: ['./customer-info.component.scss']
})
export class CustomerInfoComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<CustomerInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
    private orderService: OrderService,
    private fb: FormBuilder,
    private profileService: ProfileService
  ) { }

  orderForm = this.fb.group({
    user_id: new FormControl(''),
    emailReferens: new FormControl('', Validators.required),
    firstName: new FormControl('', Validators.required),
    lastName: new FormControl('', Validators.required),
    shipment_method: new FormControl([], Validators.required),
    company: new FormControl(''),
    phone: new FormControl('', Validators.required),
    settings_id: new FormControl(''),
    otherShippingAddress: new FormControl(false),
    address: new FormControl('', Validators.required),
    city: new FormControl('', Validators.required),
    country: new FormControl('', Validators.required),
    province: new FormControl(''),
    zipcode: new FormControl('', Validators.required),
    address_2: new FormControl('', Validators.required),
    city_2: new FormControl('', Validators.required),
    country_2: new FormControl('', Validators.required),
    province_2: new FormControl(''),
    zipcode_2: new FormControl('', Validators.required),
    discountCode: new FormControl(''),
    coustumerMessage: new FormControl(''),
  });
  @Input() article: any;
  @Output() orderEmitter = new EventEmitter<any>();
  shipping_methods: any = [];
  user: any;
  countries: any = [];
  provinces: any = [];
  country: any = {
    alpha2_code: '',
    country: '',
    country_code: 0,
    currency: '',
    province: [],
    vat: 0
  };
  country_2: any;
  vat: number = 0;
  price: number;
  totalPrice: number;
  paymentmethods: any;
  discounts: any = [];
  discount: any;
  totalDiscount: any;
  orders: any = [];
  organization: any;
  discountLow: any
  invalidDiscount: any;

  onChanges(): void {

    this.orderForm.get('country').valueChanges.subscribe(country =>{
      this.countries.forEach(element => {
        if(element.country == country){
          this.country = element;
        }
      });
      if(this.country.province.length <= 0){
        this.orderForm.patchValue({
          province: ''
        });
      }
      else{
        this.orderForm.patchValue({
          province: this.country.province[0].name
        });
      }
    })

    this.orderForm.get('country_2').valueChanges.subscribe(country =>{
      this.countries.forEach(element => {
        if(element.country == country){
          this.country_2 = element;
        }
      }); 
      if(this.country_2.province.length <= 0){
        this.orderForm.patchValue({
          province_2: ''
        });
      }
      else{
        this.orderForm.patchValue({
          province_2: this.country_2.province[0].name
        });
      }
    })  

    this.orderForm.get('otherShippingAddress').valueChanges.subscribe(res =>{
      this.countries.forEach(element => {
        if(element.country == this.orderForm.value.country_2){
          this.country_2 = element;
        }
      }); 
      if(this.country.province.length <= 0){
        this.orderForm.patchValue({
          province_2: ''
        });
      }
      else{
        this.orderForm.patchValue({
          province_2: this.country.province[0].name
        });
      }
    }) 

    this.orderForm.get('address').valueChanges.subscribe(address =>{
      if(!this.orderForm.value.otherShippingAddress){
        this.orderForm.patchValue({
          address_2: address
        });
      }
    }) 
    this.orderForm.get('zipcode').valueChanges.subscribe(zipcode =>{
      if(!this.orderForm.value.otherShippingAddress){
        this.orderForm.patchValue({
          zipcode_2: zipcode,
        });
      }
    })  
    this.orderForm.get('city').valueChanges.subscribe(city =>{
      if(!this.orderForm.value.otherShippingAddress){
        this.orderForm.patchValue({
          city_2: city,
        });
      }
    })

    this.orderForm.valueChanges.subscribe(form =>{
      if(this.discount){
        this.price = parseFloat(((this.article.price  * this.article.quantity) - this.totalDiscount + this.orderForm.value.shipment_method['price']).toFixed(2));
      }
      else{
        this.price = parseFloat((((this.article.price  * this.article.quantity) ) + this.orderForm.value.shipment_method['price']).toFixed(2));
      }
      if(this.country){
        this.vat = parseFloat((this.price * this.country['vat']).toFixed(2));
      }
      this.totalPrice = Math.round( (this.price + this.vat) * 100)/100;
      
    })

  }

  calculateDiscount(discount){
    let discountProcentage: number = +discount.procentage;
    this.totalDiscount = parseFloat(((this.article.price  * this.article.quantity) * discountProcentage).toFixed(2));
    this.price = parseFloat(((this.article.price  * this.article.quantity) - this.totalDiscount + this.orderForm.value.shipment_method['price']).toFixed(2));
    this.vat = parseFloat((this.price * this.country['vat']).toFixed(2));
    this.totalPrice = Math.round( (this.price + this.vat) * 100)/100;
    
    return this.totalPrice
  }

  applyDiscount(code){
    this.discountLow = false;
    this.invalidDiscount = false;
    let oldDiscount = this.discount;
    
    this.discounts.forEach(element => {
      let i = 0;
      while (i < this.orders.length && element.usedCode != true) {
        if((this.orders[i].discount_id == element.id)){
          i = 0
          element.usedCode = true
        }
        i++;
      }
      let dateNow = new Date(new Date(new Date(new Date().setHours(2)).setMinutes(0)).setSeconds(0));
      let expiryDate = new Date(new Date(new Date(new Date(element.expiry_date).setHours(2)).setMinutes(0)).setSeconds(0));
      let activationDate = new Date(new Date(new Date(new Date(element.activation_date).setHours(2)).setMinutes(0)).setSeconds(0))
      if ((code === element.code && dateNow <= expiryDate && expiryDate >= activationDate && !element.usedCode) || (element.id === this.organization.discountCodeId) ) {
        if (this.discount == undefined || this.discount.procentage <= element.procentage && oldDiscount != element) {
          this.discount = element;
        }
        else if (this.discount.procentage > element.procentage && element.id != this.organization.discountCodeId) {
          this.discountLow = true;
        }
      }
    });
    if(this.discount != undefined){
      this.calculateDiscount(this.discount);
    }
    if(oldDiscount == this.discount){
      this.invalidDiscount = true
    }
  }

  checkout() {
    let attributeValueId = [];
    this.article.attributes.forEach(element => {
      attributeValueId.push(element.attributeValueId)
    });
    let orderArticle = {
      id: this.article.id,
      attribute_value_id: attributeValueId,
      quantity: this.article.quantity
    }

    let discountProcentage: number = 0
    let discount_id: any
    if(this.discount){
      discountProcentage = +this.discount.procentage;
    }

    let productPrice: number = + Math.round((this.article.price - (this.article.price * discountProcentage)) * 100)/100
    let order = {
      settings_id: '',
      status_id: 0,
      user: this.user,
      country: this.country,
      created_date: new Date().toISOString().slice(0, 19).replace('T', ' '),
      shipment_method_id: this.orderForm.value.shipment_method['id'],
      product_name: this.article.title,
      product_price: productPrice,
      quantity:  this.article.quantity,
      phone_nr: this.orderForm.value.phone,
      shipping_price: this.orderForm.value.shipment_method['price'],
      total_price: this.totalPrice,
      price: this.price,
      VAT: this.vat,
      otherShippingAddress: this.orderForm.value.otherShippingAddress,
      shipping_address: {},
      billing_address: {},
      articles: [],
      coustumerMessage: this.orderForm.value.coustumerMessage,
      discount_id: '',
      oid: this.user.oid || 0,
      first_name: this.orderForm.value.firstName,
      last_name: this.orderForm.value.lastName,
      email: this.orderForm.value.emailReferens
    }
    if(this.discount != undefined){
      order.discount_id = this.discount.id
    }
    if(this.orderForm.value.otherShippingAddress){
      
      order.shipping_address = {
        address: this.orderForm.value.address_2, 
        city: this.orderForm.value.city_2, 
        zipcode: this.orderForm.value.zipcode_2, 
        country: this.country_2['alpha2_code'],
        province: this.orderForm.value.province_2
      };
      order.billing_address = {
        address: this.orderForm.value.address, 
        city: this.orderForm.value.city, 
        zipcode: this.orderForm.value.zipcode, 
        country: this.country['alpha2_code'],
        province: this.orderForm.value.province
      };
    }
    else{
      order.shipping_address = {
        address: this.orderForm.value.address, 
        city: this.orderForm.value.city, 
        zipcode: this.orderForm.value.zipcode, 
        country: this.country['alpha2_code'],
        province: this.orderForm.value.province
      };
      order.billing_address = {
        address: this.orderForm.value.address, 
        city: this.orderForm.value.city, 
        zipcode: this.orderForm.value.zipcode, 
        country: this.country['alpha2_code'],
        province: this.orderForm.value.province
      };
    }
    order.articles.push(orderArticle)
    this.orderEmitter.emit(order);
  }

  async ngOnInit() {
    
    await this.orderService.getOrders().then((response: any) =>{
      this.orders = response
    }, err => {
      console.log(err)
    })

    
    
    this.orderService.getShippingMethod().then((response: any) =>{
      this.shipping_methods = response;
      this.orderForm.patchValue(
        {
          shipment_method: this.shipping_methods[0]
        }
      )
    }, err => {
      console.log(err)
    })

    this.orderService.getPaymentMethods().then((response: any) =>{
      this.paymentmethods = response;
    }, err => {
      console.log(err)
    })

    this.profileService.getUserProfile().subscribe(async (response: any) => {
      this.user = {
        firstname: response.payload.data().firstName || '',
        lastname: response.payload.data().lastName || '',
        address: response.payload.data().address || '',
        city: response.payload.data().city || '',
        company: response.payload.data().company || '',
        country: response.payload.data().country || '',
        province: response.payload.data().province || '',
        email: response.payload.data().email || '',
        phone: response.payload.data().phone || '',
        zipcode: response.payload.data().zipcode || '',
        oid: response.payload.data().oid || '',
      }
      
      if(this.user.oid != ''){
        this.orderService.getOrganizationByid(this.user.oid).then((response: any) =>{
          this.organization = {
            id: response[0].id,
            name: response[0].name,
            discountCodeId: response[0].discountCodeId,
            url: response[0].url
          }

          this.orderService.getDiscounts().then((response: any) =>{
            this.discounts = response
            this.applyDiscount("")
          }, err => {
            console.log(err)
          })
        })
      }
      else{
        this.organization = {
          id: '',
          name: '',
          discountCodeId: '',
          url:''
        }
        this.orderService.getDiscounts().then((response: any) =>{
          this.discounts = response
        }, err => {
          console.log(err)
        })
      }
     
      this.orderForm.patchValue(
        {
          firstName: this.user.firstname,
          lastName: this.user.lastname,
          address: this.user.address,
          zipcode: this.user.zipcode,
          city: this.user.city,
          company: this.user.company,
          country: this.user.country,
          province: this.user.province,
          emailReferens: this.user.email,
          phone: this.user.phone,
          address_2: this.user.address,
          zipcode_2: this.user.zipcode, 
          city_2: this.user.city,
          country_2: this.user.country,
          province_2: this.user.province,
        }
      );
        
      this.onChanges();
      await this.orderService.getCountries().then((res: any) => {
        let countries = res.sort((a, b) => (a.country < b.country) ? -1 : 1);

        this.orderService.getProvinces().then((res: any) => {
          this.provinces = res.sort((a, b) => (a.name < b.name) ? -1 : 1);;
          countries.forEach(element => {
            element.province = [];
            
            this.provinces.forEach(province => {
              if(element.alpha2_code == province.alpha2_code){
                element.province.push(province);
              }
              if(element.country == this.orderForm.value.country){
                this.country = {
                    alpha2_code: element.alpha2_code,
                    country: element.country,
                    country_code: element.country_code,
                    currency: element.currency,
                    province: element.province,
                    vat: element.vat
                  }
              }
            });
            this.countries.push(element)
          });
          
          if(this.country){
            this.vat = parseFloat((this.price * this.country['vat']).toFixed(2));
            this.totalPrice = Math.round( (this.price + this.vat) * 100)/100
          }
        }, err => {
          console.log(err)
        } // Show error
        )
  
      }, err => {
        console.log(err)
      } // Show error
      )

    })
    
    
  }

}
